'use client';

import React, { Component } from 'react';
import './style.sass';

import Ciphers from '../reusable-components/layouts-components__nanoteh/ciphers';
import Results from '../reusable-components/layouts-components__nanoteh/results';
import Process from '../reusable-components/layouts-components__nanoteh/process';
import Complex from '../reusable-components/layouts-components__nanoteh/complex';
import Team from '../reusable-components/layouts-components__nanoteh/team';
import Tasks from '../reusable-components/layouts-components__nanoteh/tasks';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import { getAdjacentCase } from '../../../../../shared/utilities/GetAdjacentCase/getAdjacentCase';

import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import MainTitle from '../reusable-components/layouts-components__common-cases/main-title';

import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';
import CommonSmallTitle from '../common-components/common-small-title';
import CommonSmallText from '../common-components/common-small-text';

const gensMainTitle = {
    titleMainText: `450 ключевых слов в&nbsp;ТОП-3 за&nbsp;полгода`,
    titleAnimation: '/images/pic/preview/nanoteh.png',
    subtitleContainer: [
        {
            modeText: 'клиент',
            colorMode: '#3498dc',
            nameText: 'АО&nbsp;&laquo;РМ&nbsp;Нанотех&raquo;',
        },
        {
            modeText: 'Отрасль',
            colorMode: '#3498dc',
            nameText: 'Нанотехнологии',
        },
        {
            modeText: 'Услуги',
            colorMode: '#3498dc',
            nameText: 'SEO',
        },
        {
            modeText: 'Технологии',
            colorMode: '#3498dc',
            nameText: 'Технические тесты',
            subnameText:
                'Screaming Frog, Google PageSpeed Tools, GTmetrix, Dareboost, cURL, Bertal',
        },
        {
            nameText: 'Текстовые анализаторы и кластеризаторы, сервисы сбора позиций:',
            subnameText:
                'SEMparser, Топвизор, Яндекс.XML, Key Collector, Ahrefs, SimilarWeb, Text.ru',
        },
    ],
};

class Nanoteh extends Component {
    render() {
        const casePathname = '/cases/marketing/nanoteh';
        const adjacentCase = getAdjacentCase(casePathname);

        return (
            <section className="converter">
                <MainTitle MainTitle={gensMainTitle}>
                    <CommonSmallTitle className="nanoteh__subtitle">РМ Нанотех</CommonSmallTitle>
                    <CommonSmallText>
                        Это единственная российская компания среди мировых производителей мембранной
                        продукции. РМ&nbsp;Нанотех производит наноструктурированное мембранное
                        полотно, рулонные мембранные элементы для обратного осмоса, нанофильтрации
                        и&nbsp;ультрафильтрации для получения чистой воды.
                    </CommonSmallText>
                </MainTitle>

                <Tasks />

                <Complex />

                <Process />

                <Results />

                <Ciphers />

                <Team />

                <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                    <FullWrapper>
                        <OfferButton linkText="Нанять команду" />
                    </FullWrapper>
                </ScrollAnimation>

                {adjacentCase && (
                    <NextProject
                        NextProject={{
                            nextProjectTitle: adjacentCase.case.title,
                            nextProjectImg: adjacentCase.case.image,
                            nextProjectLink: adjacentCase.case.router,
                            nextProjectText: adjacentCase.case.description,
                            nextProjectLabel: adjacentCase.label,
                        }}
                    />
                )}
            </section>
        );
    }
}

export default Nanoteh;
